import React from 'react';
import classNames from 'classnames';
import { botClassName } from '../../../../utils/e2eBotUtils';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import { ValuePropItem, ValuePropsList } from '../../../../components/elements/ValuePropsList';
const styles = require('./Hero.module.css');

export const ValueProps = ({ valueProps, valuePropIcon }) => {
  return (
    <ValuePropsList className={styles.heroValueList}>
      {valueProps.map((valueProp, i) => {
        return (
          <ValuePropItem
            key={`hero_valueProp_${i}`}
            icon={valuePropIcon}
            iconSize="small"
            alignItems="flex-start"
          >
            <CodeSparkThemedTypography
              variant="subtitle3"
              className={styles.heroValueProp}
              parseText
            >
              {valueProp}
            </CodeSparkThemedTypography>
          </ValuePropItem>
        );
      })}
    </ValuePropsList>
  );
};

export const HeroTitle = ({ children, ...props }) => (
  <CodeSparkThemedTypography variant="h1" {...props}>
    {children}
  </CodeSparkThemedTypography>
);

export const HeroLeft = ({ children, className }) => (
  <div
    className={classNames(
      botClassName('hero-left'),
      'cell',
      'medium-12',
      'large-6',
      styles.heroLeft,
      className
    )}
  >
    {children}
  </div>
);

export const HeroRight = ({ children, className }) => (
  <div
    className={`${botClassName('hero-right')} cell medium-12 large-6 ${styles.heroRight} ${
      className ? className : ''
    }`}
  >
    {children}
  </div>
);

export const Image = ({ src, className }) => {
  return (
    <div className={classNames(styles.heroImageWrapper, className)}>
      <img src={src} alt="Hero" />
    </div>
  );
};

function Announcement({ top, bottom, banner }) {
  return (
    <div className={styles.announcement}>
      <CodeSparkThemedTypography variant="body3" className={styles.heroRightText}>
        {top}
      </CodeSparkThemedTypography>
      <div
        className={styles.banner}
        style={{ color: banner.textColor, backgroundColor: banner.backgroundColor }}
      >
        {banner.text}
      </div>
      <CodeSparkThemedTypography variant="body3" className={styles.heroRightText}>
        {bottom}
      </CodeSparkThemedTypography>
    </div>
  );
}

export const HeroRightImage = ({ image, announcement }) => {
  return (
    <HeroRight>
      {announcement && <Announcement {...announcement} />}
      <Image src={image} />
    </HeroRight>
  );
};

export const HeroWrapper = ({ children, className }) => {
  return (
    <section className={`${botClassName('hero')} ${styles.heroSection} ${className}`}>
      <div className={`grid-x grid-padding-x align-middle ${styles.heroSectionContent}`}>
        {children}
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Hero/components.js